export default "__VITE_ASSET__bYU8$Ch4__"